import { useState } from 'react';
import type { StepProps } from './types';

type Props = Pick<StepProps, 'formData' | 'onChange' | 'onNext' | 'onBack'>;

const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '12px 14px',
  border: '1.5px solid #e2e8f0',
  borderRadius: '8px',
  fontSize: '15px',
  fontFamily: "'Zen Maru Gothic', sans-serif",
  outline: 'none',
  color: '#333',
};

const backBtnStyle: React.CSSProperties = {
  background: 'transparent',
  border: 'none',
  color: '#bbb',
  fontSize: '12px',
  cursor: 'pointer',
  padding: '4px 8px',
  textDecoration: 'underline',
};

export default function StepAddressName({ formData, onChange, onNext, onBack }: Props) {
  const [zipLoading, setZipLoading] = useState(false);
  const [zipError, setZipError] = useState('');

  const handleZipChange = async (zip: string) => {
    const normalized = zip.replace(/[^0-9]/g, '');
    onChange('zipCode', normalized);
    setZipError('');
    if (normalized.length === 7) {
      setZipLoading(true);
      try {
        const res = await fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${normalized}`);
        const data = await res.json();
        if (data.results && data.results.length > 0) {
          onChange('prefecture', data.results[0].address1);
          onChange('city', data.results[0].address2);
        } else {
          onChange('prefecture', '');
          setZipError('郵便番号が見つかりませんでした');
        }
      } catch {
        setZipError('住所の取得に失敗しました');
      } finally {
        setZipLoading(false);
      }
    }
  };

  const canNext = formData.zipCode.length === 7 && formData.name.trim().length > 0;

  const handleNext = () => {
    if (!canNext) return;
    onNext();
  };

  return (
    <div>
      <p style={{ fontWeight: 700, fontSize: '15px', marginBottom: '14px', color: '#333' }}>
        Q3. 郵便番号とお名前を入力してください
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: '20px' }}>
        {/* 郵便番号 */}
        <div>
          <label style={{ fontSize: '13px', color: '#666', display: 'block', marginBottom: '6px', fontWeight: 600 }}>
            お住まい・ご希望勤務地の郵便番号
            <span style={{ fontSize: '11px', color: '#fa7c9e', marginLeft: '6px' }}>7桁・ハイフンなし</span>
          </label>
          <div style={{ position: 'relative' }}>
            <input
              style={inputStyle}
              placeholder="1234567"
              value={formData.zipCode}
              maxLength={7}
              inputMode="numeric"
              onChange={(e) => handleZipChange(e.target.value)}
            />
            {zipLoading && (
              <span style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', fontSize: '12px', color: '#fa7c9e' }}>
                検索中...
              </span>
            )}
          </div>
          {zipError && (
            <p style={{ color: '#dc3545', fontSize: '12px', marginTop: '4px' }}>{zipError}</p>
          )}
          {formData.prefecture && !zipError && (
            <p style={{ color: '#4caf50', fontSize: '12px', marginTop: '4px' }}>
              ✓ {formData.prefecture}{formData.city}
            </p>
          )}
        </div>

        {/* お名前 */}
        <div>
          <label style={{ fontSize: '13px', color: '#666', display: 'block', marginBottom: '6px', fontWeight: 600 }}>
            お名前
            <span style={{ fontSize: '11px', color: '#aaa', marginLeft: '6px' }}>苗字だけでもOK</span>
          </label>
          <input
            style={inputStyle}
            placeholder="山田"
            value={formData.name}
            onChange={(e) => onChange('name', e.target.value)}
          />
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
        <div style={{ textAlign: 'center' }}>
          <p style={{ fontSize: '11px', color: '#ff5c73', marginBottom: '6px', fontWeight: 700 }}>完全無料！</p>
          <button
            className="btn-next"
            style={{ padding: '15px 24px', fontSize: '15px', minWidth: '200px' }}
            onClick={handleNext}
            disabled={!canNext}
          >
            次のステップへ
          </button>
        </div>
        <button style={backBtnStyle} onClick={onBack}>
          ← 前の質問に戻る
        </button>
      </div>
    </div>
  );
}